import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Button, Icon, Title } from '@express-labs/raven-ui';
import { cn } from '@express-labs/raven-tools';

import s from './MyAccountLink.module.scss';

const SIGN_OUT = 'Sign Out';
function MyAccountLink({
  ariaLabel,
  icon,
  route,
  state,
  title,
}) {
  const handleClick = useCallback(() => {
    if (state && state !== null) {
      window.history.pushState(state, '', route);
    }
    window.location.assign(route);
  }, [route, state]);

  if (title === SIGN_OUT) {
    return (
      <div className={s.signOut}>
        <Button
          mode="ghost"
          as="a"
          size="large"
          theme="dark"
          onClick={handleClick}
          aria-label={ariaLabel}
          className={s.signOutButton}
        >
          {title}
        </Button>
      </div>
    )
  }

  return (
    <Button
      mode="solid"
      as="a"
      size="large"
      theme="light"
      className={s.subContainer}
      onClick={handleClick}
      aria-label={ariaLabel}
    >
      <Icon icon={icon} />
      <div className={cn(s.description)}>
        <Title tag="h5" className={s.cardTitle}>{title}</Title>
      </div>
    </Button>
  );
}

MyAccountLink.meta = {
  VERSION: '1.0.0',
};

MyAccountLink.propTypes = {
  ariaLabel: PropTypes.string,
  icon: PropTypes.string.isRequired,
  route: PropTypes.string,
  state: PropTypes.shape({
    userLoggedOut: PropTypes.bool,
  }),
  title: PropTypes.string.isRequired,
};

MyAccountLink.defaultProps = {
  ariaLabel: '',
  route: '',
  state: null,
};

export default MyAccountLink;
